import { idFlavor } from "./flavors";

export const EventTypes = {
  INDEX_CML: "index-cml",
} as const;

export type EventType = keyof typeof EventTypes;

export type EventJob =
  | {
      type: EventType;
    }
  | {
      type: "index-cml";
      cmlId: idFlavor<"CampaignMetaLog">;
    };
